import { render, staticRenderFns } from "./IntgrLoading.vue?vue&type=template&id=7f7ace40&scoped=true&"
import script from "./IntgrLoading.vue?vue&type=script&lang=ts&"
export * from "./IntgrLoading.vue?vue&type=script&lang=ts&"
import style0 from "./IntgrLoading.vue?vue&type=style&index=0&id=7f7ace40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7ace40",
  null
  
)

export default component.exports